export default "__VITE_PUBLIC_ASSET__3e0c96d7__"